import { useNavigate } from 'react-router-dom'
import BackHeader from '../../components/BackHeader/BackHeader'
import { useHold } from './store'
import Loading from '../../components/Loading/Loading'
import { Composer, HoldScreen } from './bits'
import TextCard from './components/TextCard'

export default function WallView() {
  const navigate = useNavigate()
  const { team, dispatch, nameOf, meId, loading } = useHold()
  if (loading && !team) return <HoldScreen><Loading fill /></HoldScreen>
  if (!team) return null

  return (
    <HoldScreen>
      <BackHeader eyebrow={team.name} title="Væg" onBack={() => navigate(`/hold/${team.id}`)} />
      <div className="hold-stack">
        <TeamWall team={team} posts={team.posts} dispatch={dispatch} nameOf={nameOf} meId={meId} />
        {team.posts.length === 0 ? <p className="hold-empty">Ingen opslag endnu.</p> : null}
      </div>
    </HoldScreen>
  )
}

export function TeamWall({ team, posts, dispatch, nameOf, meId, showComposer = true }) {
  return (
    <>
      {showComposer ? (
        <Composer
          allowImage
          placeholder="Skriv et opslag til holdet"
          onSubmit={(text, image) => dispatch({ type: 'ADD_POST', teamId: team.id, text, image })}
        />
      ) : null}
      {posts.length === 0 ? null : posts.map((post) => (
        <div key={post.id} className="hold-stack">
          <TextCard
            text={post.text}
            image={post.image}
            allowImage
            meta={post.authorName || nameOf(post.authorId)}
            at={post.createdAt}
            canEdit={post.authorId === meId}
            like={{
              count: (post.likedBy || []).length,
              people: [...(post.likedBy || [])]
                .map((id) => ({ id, name: nameOf(id) }))
                .sort((a, b) => a.name.localeCompare(b.name, 'da')),
              on: (post.likedBy || []).includes(meId),
              onToggle: post.authorId === meId
                ? null
                : () => dispatch({ type: 'TOGGLE_POST_LIKE', teamId: team.id, postId: post.id }),
            }}
            onSave={(text, image) => dispatch({ type: 'UPDATE_POST', teamId: team.id, postId: post.id, text, image })}
            onDelete={() => dispatch({ type: 'DELETE_POST', teamId: team.id, postId: post.id })}
            canComment={true}
            onCommenting={(text) => dispatch({ type: 'ADD_COMMENT', teamId: team.id, postId: post.id, text })}
          />
          <div className="hold-comments">
            {post.comments.map((comment) => (
              <TextCard
                key={comment.id}
                compact
                text={comment.text}
                meta={comment.authorName || nameOf(comment.authorId)}
                at={comment.createdAt}
                canEdit={comment.authorId === meId}
                mine={comment.authorId === meId}
                onSave={(text) => dispatch({ type: 'UPDATE_COMMENT', teamId: team.id, commentId: comment.id, text })}
                onDelete={() => dispatch({ type: 'DELETE_COMMENT', teamId: team.id, commentId: comment.id })}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}